import React from 'react';
import { motion } from 'framer-motion';
import { ScrollReveal } from './ScrollReveal';
import { useClient } from './ClientContext';
const steps = [{
  id: '01',
  title: 'Discover',
  color: '#3B82F6',
  description: 'We start by understanding the product, audience and context. This includes the problem the brand needs to solve, how it will be used and what success looks like. The goal is shared clarity before any design decisions are made.',
  included: ['In person deep dive session', 'Desktop research', 'Competitor analysis', 'Key findings summary']
}, {
  id: '02',
  title: 'Define',
  color: '#FACC15',
  description: 'We define the key decisions that shape the brand. This stage creates clarity around who the brand is for, what it needs to say, and how it should sound so design can move forward with confidence.',
  included: ['Clear target audience and focus', 'Core messages', 'Tone of voice principles', 'Design direction and boundaries']
}, {
  id: '03',
  title: 'Design',
  color: '#8B5CF6',
  description: 'We create the core design foundations for the brand. This includes a clear visual direction and the essential elements needed to apply the brand with confidence.',
  included: ['Visual direction', 'Core brand elements', 'Ready to use design assets']
}, {
  id: '04',
  title: 'Deliver',
  color: '#EF4444',
  description: 'We package and hand over the work clearly so the brand can be used with confidence from day one.',
  included: ['Final brand assets', 'Usage guidance', 'Clean handover']
}];
export function ApproachTimeline() {
  const {
    companyName
  } = useClient();
  return <section id="approach" className="py-24 px-6 bg-white" data-id="element-17">
      <div className="max-w-7xl mx-auto" data-id="element-18">
        <ScrollReveal data-id="element-19">
          <div className="mb-16" data-id="element-20">
            <h2 className="text-sm font-bold tracking-widest text-accent mb-2" data-id="element-21">
              {companyName}: Our approach
            </h2>
          </div>
        </ScrollReveal>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12" data-id="element-22">
          {steps.map((step, index) => <ScrollReveal key={step.id} delay={index * 0.1} data-id="element-23">
              <div className="flex flex-col h-full" data-id="element-24">
                <motion.div className="w-24 h-24 rounded-full flex items-center justify-center mb-8 shadow-lg" style={{
              backgroundColor: step.color
            }} initial={{
              opacity: 0,
              y: 16
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              margin: '-50px'
            }} transition={{
              duration: 0.5,
              delay: index * 0.12,
              ease: [0.25, 0.1, 0.25, 1]
            }} data-id="element-25">
                  <span className="text-3xl font-bold text-white" data-id="element-26">
                    {step.id}
                  </span>
                </motion.div>

                <h3 className="text-2xl font-extrabold text-navy mb-6" data-id="element-27">
                  {step.title}
                </h3>

                <p className="text-gray-600 text-sm leading-relaxed min-h-[160px]" data-id="element-28">
                  {step.description}
                </p>

                <div className="mt-auto pt-6" data-id="element-29">
                  <h4 className="text-accent font-bold text-sm mb-4" data-id="element-30">
                    What's included:
                  </h4>
                  <ul className="space-y-2" data-id="element-31">
                    {step.included.map((item, i) => <li key={i} className="flex items-start text-sm text-gray-500" data-id="element-32">
                        <span className="mr-3 mt-1.5 w-1.5 h-1.5 rounded-full bg-accent flex-shrink-0" data-id="element-33" />
                        {item}
                      </li>)}
                  </ul>
                </div>
              </div>
            </ScrollReveal>)}
        </div>
      </div>
    </section>;
}